<template>
	<div>
		<span class="offer-info" v-if="!isAll">
			<span class="design-line">
				Az alábbi ajánlatok nem tartalmazzák a következő kiegészítő szolgáltatás(oka)t:
				<br />
				<strong v-for="(missing, index) in computedMissing" :key="index">
					{{ missing }}{{ computedMissing.length !== index + 1 ? ',' : '' }}
				</strong>
			</span>
		</span>
        <p style="font-size: 14px;margin-bottom: 2.5rem;text-align: justify;color: #706F6F;" v-if="!isAll">Kérjük, szíveskedjen az alapcsomagban lévő fedezeteket és a biztosítási összegeket ellenőrizni, a kiegészítő biztosításoknál több esetben az alapcsomag is tartalmaz megfelelő fedezetet, a kiegészítő biztosítások azonban többlet szolgáltatást tartalmazhatnak! Az ellenőrzést a következő <a href="/pdf/mfo_kiegeszito_biztositasok_alapcsomag.pdf" target="_blank">linken</a> tudja megtenni.</p>
        <div class="calclists box-white page-break" v-for="(offer, index) in offers" :key="index" :ref="`${index}offer`">
			<div class="calclist">
				<div class="calclist-boxes calclist-box-01" v-show="computedShow(index)">
					<div class="calclist-box-row-01 calclist-box-title">{{ offer.insurer_name }} Biztosító</div>
					<div class="calclist-box-row-02 calclist-box-logo">
						<img :src="offer.logo" :alt="offer.insurer_name" />
					</div>
					<div class="calclist-box-row-03 calclist-box-info"></div>
				</div>
				<div class="calclist-boxes calclist-box-02" v-show="computedShow(index)">
					<div class="calclist-box-row-01 calclist-box-title">
						Biztosítási összeg
						<span class="info"></span>
					</div>
					<strong class="calclist-box-row-02 calclist-box-amount">
						{{ offer.sum_fee | toCurrency }}
					</strong>
					<div class="calclist-box-row-03 calclist-box-info">Az összeg eloszlását lásd a részletek alatt</div>
				</div>
				<div class="calclist-boxes calclist-box-03" v-show="computedShow(index)">
					<div class="calclist-box-row-01 calclist-box-title">
						Díj
						<span class="info"></span>
					</div>
					<div class="calclist-box-row-02 calclist-box-amount">
						<div>
							<span>Éves díj:</span>
							<strong class="ml-5px d-intable">
								{{ offer.annual_fee | toCurrency }}
							</strong>
						</div>
					</div>
					<div class="calclist-box-row-03 calclist-box-info">Alapcsomag és kiegészítő díj</div>
				</div>
				<div class="calclist-boxes calclist-box-04" v-show="computedShow(index)">
					<div class="calclist-box-row-01 calclist-box-title">
						Fizetendő díj
						<span class="info"></span>
					</div>
					<div class="calclist-box-row-02 calclist-box-amount">
						<div>
							<span>{{ paymentFrequencyTexts[getCalculation.payment_frequency] }}:</span>
							<strong class="ml-5px d-intable">
								{{ offer.frequency_fee | toCurrency }}
							</strong>
						</div>
					</div>
					<div class="calclist-box-row-03 calclist-box-info">
						Éves díj: {{ offer.annual_fee | toCurrency }}
					</div>
				</div>
				<CalcResultDetails v-if="isOpen.includes(index) && isMobile" :offer="offer" :mobile="true" />
				<div class="calclist-boxes calclist-box-05" v-if="!print">
					<div class="calclist-box-row-01 calclist-box-title"></div>
					<div class="calclist-box-row-02">
						<button class="calclist-box-btn btn-blue" @click="handleContracting(offer)">
							Ezt választom
						</button>
					</div>
					<div class="calclist-box-row-03 calclist-box-info toggle" @click="toggle(index)">
						<span :class="['toggleArrow', isOpen.includes(index) ? 'open' : '']">Részletek</span>
					</div>
				</div>
			</div>
			<CalcResultDetails v-if="(isOpen.includes(index) && !isMobile) || print" :offer="offer" :print="print"/>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';
import CalcResultDetails from '@/components/CalcResultDetails.vue';
import isMobile from 'is-mobile';
import DataLayer from '@/helpers/dataLayer.js';

export default {
	props: {
		offers: { type: [Array, Object], default: () => null },
		isAll: { type: Boolean, default: false },
        print: { type: Boolean, default: false },
	},
	data() {
		return {
			show: false,
			content: '',
			isOpen: [],
			paymentFrequencyTexts: {
				0: 'Havonta',
				1: 'Negyedévente',
				2: 'Félévente',
				3: 'Évente',
			},
		};
	},
	computed: {
		...mapGetters(['getCalculation', 'getInsuranceEventNameById']),
		...mapGetters('auth', ['isLoggedIn', 'getCurrentUser', 'isCustomerService', 'isAdmin', 'isVerified']),
		computedMissing() {
			if (!this.isAll) {
				let results = [];

				_.each(this.offers.missings, missing => {
					if (missing !== undefined && missing !== null) {
						results.push(this.getInsuranceEventNameById(missing));
					}
				});

				return results;
			}
		},
		isMobile() {
			return isMobile();
		},
		computedShow() {
			return index => {
				return this.isMobile ? !this.isOpen.includes(index) : true;
			};
		},
	},
	components: {
		CalcResultDetails,
	},
	methods: {
		...mapMutations(['showPopup']),
		...mapMutations('contracting', ['setSelectedOffer']),
		...mapActions(['updateUserId','saveSelectedOffer']),
		toggle(index) {
			if (this.isMobile) {
				this.$scrollTo(this.$refs[`${index}offer`][0], 500);
			}

			if (this.isOpen.includes(index)) {
				this.isOpen = this.isOpen.filter(i => i !== index);
				return;
			}

			this.isOpen.push(index);
		},
		async handleContracting(offer) {
			DataLayer.setEvent('Ajanlat_valasztas', { Biztosíto: offer.insurer_name });
			this.setSelectedOffer(offer);

			if (this.getCurrentUser === null) {
				this.showPopup('ContractingRegistration');
			} else if (!this.isVerified) {
				this.showPopup('ContractingVerify');
			} else {
                await this.saveSelectedOffer({hash: this.$route.params.hash, insurerUuid:offer.insurer_uuid});
				//await this.updateUserId();
				this.$router.push({
					name: 'contracting-base',
					params: {
						hash: this.$route.params.hash,
						insurer_uuid: offer.insurer_uuid,
					},
				});
			}
		}
	},
};
</script>

<style scoped>
@media print {
    .page-break {
        display: block;
        break-after: always;
        page-break-after: always;
    }
}
</style>
